import React from 'react';
import './PageHero.css';

interface PageHeroProps {
  title: string;
  subtitle: string;
  className?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ title, subtitle, className = '' }) => {
  return (
    <section className={`page-hero ${className}`}>
      <div className="section-container">
        <div className="page-hero-content">
          <h1>{title}</h1>
          <p className="page-subtitle">{subtitle}</p>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
